<div class="card">
  <div class="header">编辑资料</div>

  <div class="content">
    <div class="avatar">
      <app-user-avatar
        [fileid]="self?.avatar"
        size="96px"
        (click)="fileinput.click()"
      >
      </app-user-avatar>
      <div class="detail">
        <div class="txt1">修改头像</div>
        <div class="txt2" (click)="fileinput.click()">上传新图片</div>
        <div class="txt3">支持 JPG, PNG 格式，最大 2MB</div>
      </div>
    </div>

    <div class="info">
      <div class="item">
        <div class="left">
          <span class="title">昵称</span>
          <span class="value" (click)="updateNickname()">
            {{ self?.nickname || "环球巴士" }}
            <div class="space"></div>
            <img class="edit" src="../../../../assets/images/edit.png" />
          </span>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <span class="title">手机号</span>
          <span class="value" (click)="updatePhone()">
            {{ self?.phone || "" }}
            <div class="space"></div>
            <img class="edit" src="../../../../assets/images/edit.png" />
          </span>
        </div>
      </div>
      <div class="item" *ngIf="self?.email">
        <div class="left">
          <span class="title">邮箱号</span>
          <span class="value">{{ self?.email || "" }}</span>
        </div>
        <!-- <img src="../../../../assets/images/edit.png" (click)="updatePhone()" /> -->
      </div>
      <div class="item">
        <div class="left">
          <span class="title">社交账号绑定</span>
          <span class="value" (click)="bindWechat()">
            <img class="wx" src="../../../../assets/images/weixin.svg" alt="" />
            <span class="wx">
              <div class="txt1">微信 (WeChat)</div>
              <div class="txt2" *ngIf="this.self?.publicid">已绑定</div>
            </span>
          </span>
        </div>
      </div>
      <div class="item">
        <div class="left">
          <span class="title">登录密码</span>
          <span class="value" (click)="updatePassword()"> 修改登录密码 </span>
        </div>
      </div>

      <div class="divider"></div>

      <div class="item action">
        <div class="left">
          <!-- <span class="title">退出登录</span> -->
          <span class="value" (click)="logout()"> 退出登录 </span>
        </div>
      </div>
    </div>
  </div>
  <app-global-loading *ngIf="loading"></app-global-loading>
</div>

<input
  type="file"
  accept="image/png,image/jpeg"
  #fileinput
  style="visibility: hidden"
  (change)="onImageSelected($event)"
/>
